export default __webpack_public_path__ + "dffd980.png";